import * as batchOrderReportUploadsActions from "../../actions/batchOrderReportUploadsActions";
import * as transactionReportUploadsActions from "../../actions/transactionReportUploadsActions";
import * as bulkOrderlogActions from "../../actions/bulkOrderLogActions";

export const batchProcessingConfigs = {
  batchProcessingOrderUpload: {
    title: "Batch Processing Order History",
    fetchAction:
      batchOrderReportUploadsActions.fetchBatchOrderReportUploadsList,
    fetchTotalAction:
      batchOrderReportUploadsActions.fetchBatchOrderReportUploadsTotal,
    dataKey: "batchOrderReportUploadsList",
    stateKey: "batchOrderReportUploadsList",
    reduxStateKey: "batchOrderReportUploadsList",
    defaultLimit: batchOrderReportUploadsActions.DEFAULT_LIMIT,
    context: "order",
  },
  batchProcessingBulkTransactionUpload: {
    title: "Bulk Transaction Upload History",
    fetchAction:
      transactionReportUploadsActions.fetchTransactionReportUploadsList,
    fetchTotalAction:
      transactionReportUploadsActions.fetchTransactionReportUploadsTotal,
    dataKey: "transactionReportUploadsList",
    stateKey: "transactionReportUploadsList",
    reduxStateKey: "transactionReportUploadsList",
    defaultLimit: transactionReportUploadsActions.DEFAULT_LIMIT,
    context: "inventory",
  },
  batchProcessingBulkOrderUpload: {
    title: "Bulk Order Upload History",
    fetchAction: bulkOrderlogActions.fetchBulkOrders,
    fetchTotalAction: bulkOrderlogActions.fetchBulkOrdersTotal,
    dataKey: "bulkOrderUploadsList",
    stateKey: "bulkOrderUploadsList",
    reduxStateKey: "bulkOrderLog",
    defaultLimit: bulkOrderlogActions.DEFAULT_LIMIT,
    context: "order",
  },
};
